import { RefineKbar } from '@refinedev/kbar'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { BrowserRouter } from 'react-router'
import { customTitleHandler } from '@app/components/DocumentTitleHandler'
import { DocumentTitleHandler, UnsavedChangesNotifier } from '@refinedev/react-router'
import { Providers } from './providers'
import { AppRoutes } from './routes'

const App = () => {
  return (
    <BrowserRouter>
      <Providers>
        <AppRoutes />
        <RefineKbar />
        <UnsavedChangesNotifier />
        <DocumentTitleHandler handler={customTitleHandler} />
      </Providers>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </BrowserRouter>
  )
}

export default App
